import { styled, Theme } from '@mui/material/styles';
import { Typography } from '@mui/material';

type StylesTypes = {
  theme: Theme;
};

const StyledLabel = styled(Typography)(({ theme }: StylesTypes) => ({
  background: theme.palette.grey[300],
  borderRadius: '6px',
  padding: '3px 5px',
  marginLeft: 'auto',
  color: theme.palette.grey[700],
  textTransform: 'capitalize',
}));

const tableCellStyle = {
  maxWidth: 'sm',
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  flexGrow: 1,
};

export { StyledLabel, tableCellStyle };
